<template>
  <div>
    <div class="card" style="max-width: 100%">
      <div class="card-header"><b>Listar Flujogramas de Atención</b></div>

      <div class="card-body text-dark">
        <div class="row">
          <div class="col-sm-5">
            <b-button
              class="btn btn-add-vg"
              :to="'/grupo-eventos/rutas-atencion/crear'"
              ><i class="mdi mdi-plus"></i> Crear Flujograma de
              Atención</b-button
            ><br /><br />
          </div>
          <div class="col-sm-6">
            <b-form-input
              class="col-sm-12"
              v-model="filter"
              type="search"
              placeholder="Busqueda"
            ></b-form-input>
          </div>
          <div class="col-sm-1">
            <b-button
              class="btn btn-info"
              style="float: right"
              @click="getRutas"
              v-b-tooltip.hover
              title="Actualizar Datos"
              ><i class="mdi mdi-replay"></i
            ></b-button>
          </div>
        </div>

        <div class="text-center" v-if="loading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

        <b-table
          class="table responsive table-bordered"
          stacked="md"
          show-empty
          sticky-header
          small
          :per-page="perPage"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template #cell(actions)="row">
            <b-button
              class="btn btn-danger"
              @click="deleteRutaAtencion(row.item)"
              v-b-tooltip.hover
              title="Eliminar Flujograma de Atención"
              ><i class="mdi mdi-delete"></i
            ></b-button>
          </template>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { headers } from "./../../../api/headers";
import { configApi } from "./../../../api/configApi";
export default {
  name: "listado_grupoeventos",
  data: () => ({
    title: "",
    perPage: 10,
    filter: null,
    currentPage: 1,
    disabled: false,
    viewModal: false,
    loading: true,
    items: [],
    fields: [
      { key: "idevenruta", label: "ID", sortable: true },
      {
        key: "n_ruta",
        label: "Nombre Flujograma",
        sortable: true,
        class: "text-center",
      },
      {
        key: "n_grupoevento",
        label: "Nombre Programa",
        sortable: true,
        class: "text-center",
      },
      {
        key: "n_enfermedad",
        label: "Nombre Evento",
        sortable: true,
        class: "text-center",
      },
      { key: "actions", label: "Acciones", class: "text-center" },
    ],
    editedIndex: -1,
  }),
  computed: {
    rows() {
      return this.items.length;
    },
  },

  created() {
    this.getRutas();
  },

  methods: {
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    async getRutas() {
      return await this.axios
        .get(configApi + "grupo_eventos/rutas_atencion", { headers })
        .then((response) => {
          this.items = response.data.data;
          this.loading = false;
        });
    },
    async deleteRutaAtencion(data) {
      let objAlert = {
        titleAlert: "¿Desea eliminar el Flujograma de Atención?",
        url: configApi + "grupo_eventos/rutas_atencion/" + data.idevenruta, // url delete
        headers: { headers },
        messageError: "El Flujograma de Atención no fue Eliminado",
      };

      this.$Fun.alertaConfirmarEliminarAccion(objAlert, (e) => {
        if (e) {
          this.getRutas();
        }
      });
    },
  },
};
</script>
